import React, { useEffect, useState } from "react";
import Page from "../../component/Page";
import { getBranchList, getCatalogList } from "../setting/services/settingApi";
import api from "../../api/api";
import { saveAs } from "file-saver";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { REPORT_CONFIG } from "./config";
import { MobileDatePicker } from "@mui/x-date-pickers";
import InputSearch from "../../component/InputSearch";
const BrowserInput = function BrowserInput(props) {
  const {
    inputProps,
    InputProps,
    ownerState,
    value,
    inputRef,
    error,
    ...other
  } = props;
  return (
    <TextField
      {...inputProps}
      ref={inputRef}
      value={
        value
          ? value.substring(0, value?.length - 6) +
            (parseInt(value?.substring(value?.length - 6)) + 543).toString()
          : null
      }
      {...other}
      variant="standard"
      fullWidth
      InputProps={{
        disableUnderline: true,
      }}
    />
  );
};
export default function DaysInStockReport() {
  const [branchs, setBranchs] = useState([]);
  const [Catalog, setCatalog] = useState([]);
  const [CatalogNo, setCatalogNo] = useState("");
  const [BranchNo, setBranchsNo] = useState("");
  const [Lot, setLot] = useState("");
  const [date, setDate] = useState("");

  const [reports, setReports] = useState([]);
  const [sumValue, setSumValue] = useState();
  const [loadingDownload, setloadingDownload] = useState(false);
  const [loading, setloading] = useState(false);

  const { profile } = useSelector((state) => state.profile);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    getBranchList(null, setBranchs);
    getCatalogList(null, setCatalog);
    // LoadReport();
    // setBranchsNo(profile?.BranchNo?.BranchNo);
  }, []);
  function calculateSum() {
    const sumValue = { NetPrice: 0 };

    for (const row of reports) {
      sumValue.NetPrice += +row.NetPrice;
    }

    setSumValue(sumValue);
  }
  useEffect(() => {
    calculateSum();
  }, [reports]);

  async function getLotMovementReport(body, mode, format) {
    const url = `${REPORT_CONFIG.requests.daysInStockReport.url}/${mode}`;

    let params = {
      // ReportDate: dayjs().format("YYYY-MM-DD"),
    };

    if (body.branchNo !== "-")
      params = {
        ...params,
        BranchNo: body.branchNo || profile?.BranchNo?.BranchNo,
      };
    if (body.c !== "-") params = { ...params, CatalogNo: body.c };
    if (body.ReportDate) params = { ...params, ReportDate: dayjs(body.ReportDate).format("YYYY-MM-DD")  };
    if (format !== "-") params = { ...params, format: format };

    if (mode === "file") {
      setloadingDownload(true);
      const res = await api.get(url, {
        params: params,
        responseType: "arraybuffer",
      });
      const data = res.data;
      if (format) {
        const blob = new Blob([data], { type: "application/pdf" });
        saveAs(blob, "รายงานจำนวนวันเก็บรักษาเมล็ดพันธุ์เหลือคงคลัง");
      } else {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "รายงานจำนวนวันเก็บรักษาเมล็ดพันธุ์เหลือคงคลัง");
      }
      setloadingDownload(false);
    } else {
      setloading(true);
      const res = await api.get(url, { params: params });
      const data = res.data.result;
      setReports(data);
      setloading(false);
      setloadingDownload(false);
    }
  }
  async function LoadReport() {
    const body = {
      branchNo: BranchNo || undefined,
      ReportDate: date || undefined,
      c: CatalogNo || undefined,
    };
    getLotMovementReport(body, "data");
  }
  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <div class="container-fluid p-0">
          <form>
            <div class="row  no-gutters">
              <div class="col-12 col-lg-2">
                <div class="row no-gutters">
                  <div class="col-12 header-row border-1 ">ตัวกรอง</div>
                </div>
                <div class="row no-gutters p-2 border-1">
                  {profile?.BranchNo?.BranchNo === "00" && (
                    <div class="col-12">
                      <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                      >
                        <FormControl variant="standard" fullWidth>
                          <Select
                            value={BranchNo || "-"}
                            onChange={(e) => setBranchsNo(e.target.value)}
                            disableUnderline
                          >
                            <MenuItem value="-">-</MenuItem>
                            {branchs?.map((x) => (
                              <MenuItem value={x?.BranchNo}>
                                {x?.BranchName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </div>
                  )}

                  <div class="col-12">
                    <label class="labelInput">พันธุ์ข้าว</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <FormControl variant="standard" fullWidth>
                        <Select
                          value={CatalogNo || "-"}
                          onChange={(e) => setCatalogNo(e.target.value)}
                          disableUnderline
                        >
                          <MenuItem value="-">-</MenuItem>
                          {Catalog?.map((x) => (
                            <MenuItem value={x?.CatalogNo}>
                              {x?.CatalogName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </div>
                  <div class="col-12">
                    <label class="labelInput">วันที่</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "20px", borderRadius: "25px" }}
                    >
                      <MobileDatePicker
                        dayOfWeekFormatter={(day) => `${day}`}
                        value={date}
                        onChange={(e) => setDate(e)}
                        // maxDate={dayjs().add(1, 'day').format("YYYY-MM-DD")}
                        slotProps={{
                          textField: {
                            variant: "standard",
                            fullWidth: true,
                            InputProps: { disableUnderline: true },
                            value: date,
                          },
                        }}
                        slots={{
                          textField: BrowserInput,
                        }}
                      />
                    </Box>
                  </div>

                  <div class="col-12">
                    <Button
                      onClick={LoadReport}
                      disabled={loading ? true : false}
                      variant="contained"
                      className="ButtomSearch"
                    >
                      {loading ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ค้นหา"
                      )}{" "}
                    </Button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-between header-row border-1 ">
                    <div>รายงานจำนวนวันเก็บรักษาเมล็ดพันธุ์เหลือคงคลัง</div>
                    <Button
                      variant="contained"
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      disabled={loadingDownload ? true : false}
                      onClick={handleClick}
                    >
                      {loadingDownload ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ดาวน์โหลด"
                      )}
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      PaperProps={{
                        style: {
                          width: 100,
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          const body = {
                            branchNo: BranchNo || undefined,
                            ReportDate: date || undefined,
                            c: CatalogNo || undefined,
                          };
                          // setFormat('')
                          getLotMovementReport(body, "file");

                          handleClose();
                        }}
                      >
                        Excel
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          const body = {
                            branchNo: BranchNo || undefined,
                            ReportDate: date || undefined,
                            c: CatalogNo || undefined,
                          };
                          // setFormat('pdf')
                          getLotMovementReport(body, "file", "pdf");

                          handleClose();
                        }}
                      >
                        Pdf
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
                <div class="row no-gutters border-1 pt-3">
                  <div class="report col-12">
                    <div class="table-responsive-sm" style={{ height: "auto" }}>
                      <table class="table table-bordered table-sm table-hover">
                        <thead class="sticky-thead">
                          <tr>
                            <th scope="col">ศูนย์เมล็ดพันธุ์ข้าว</th>
                            <th scope="col">พันธุ์</th>
                            <th scope="col">ชั้นพันธุ์</th>
                            <th scope="col">ฤดู</th>
                            <th scope="col">ปีผลิต</th>
                            <th scope="col">ล็อตที่</th>
                            <th scope="col">เหลือคงคลัง</th>
                            <th scope="col">วัน-เดือน-ปี ที่รับเข้าคลัง</th>
                            <th scope="col">จำนวนวันเก็บรักษา</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reports?.map((report, i) => (
                            <tr class="cp">
                              <td class="text-center">{report?.BranchName}</td>
                              <td class="text-center">{report?.CatalogName}</td>
                              <td class="text-center">
                                {report?.Class}
                              </td>
                              <td class="text-center">
                                {report?.Season == '01' ? 'ฝน': 'แล้ง'}
                              </td>
                              <td class="text-center">
                                {report?.Year || "-"}
                              </td>
                              <td class="text-center">
                                {report?.Lot || "-"}
                              </td>
                              <td class="text-center">
                                {report?.Balance ? report?.Balance.toLocaleString() : '0'}
                              </td>
                              <td class="text-center">
                                {report?.ReceiveDate
                                  ? new Date(report?.ReceiveDate).toLocaleDateString('th', { dateStyle:'long' })
                                  : "0"}
                              </td>
                              <td class="text-center">
                                {report?.DaysInStock ? report?.DaysInStock : "0"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <thead class="sticky-tfooter">
                          <tr>
                            <th scope="col" colspan="8">
                              รวม
                            </th>
                            <th scope="col">
                              {sumValue?.NetPrice.toLocaleString()}
                            </th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
                {reports.length === 0 && (
                  <div class="row">
                    <div class="col-12">
                      <div class="not-found">ไม่พบข้อมูล</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </Page>
    </div>
  );
}
